import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const useGiftPreviewModalControls = () => {
    const { isModalOpen, openModal, closeModal, editModal, modalData } =
        useBrowserModalControls<string>('gift-preview');

    return {
        isGiftPreviewModalOpen: isModalOpen,
        uidForGiftPreviewModal: modalData,
        openGiftPreviewModal: openModal,
        closeGiftPreviewModal: closeModal,
        editGiftPreviewModal: editModal,
    };
};
